import React from "react";
import "../styles/navbar.css";

const Navbar = () => {
  return (
    <>
      <div className="navigation-split">
        <div className="links">
          <div className="link s18px">
            <a href="/">Home</a>
          </div>
          <div className="link s18px">Contact Us</div>
          <div className="link s18px">Profile</div>
          <div className="link s18px">Digest</div>
        </div>
        <h1 className="text title s24px-title">SOCIAL MEDIA DIGEST</h1>
        <div className="button-container">
          <div className="button-primary">
            <div className="text white 14px">
              <a href="/sign-in">Sign In</a>
            </div>
          </div>
          <div className="button-primary">
            <div className="text white 14px">
              <a href="/register">Register</a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Navbar;
